// DO NOT EDIT: autogenerated by brokkr
import { CreateIconOptions } from "./types";
export const falEllipsis: CreateIconOptions = {
  "displayName": "FALEllipsis",
  "viewBox": "0, 0, 448, 512",
  "d": "M416 256a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm-160 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM64 288a32 32 0 1 1 0-64 32 32 0 1 1 0 64z"
};
